import type { SessionUser } from '@shared/lib/auth/session-types'
import type { FeatureFlagUser } from './registry'

export function featureFlagUserFromSession(user: SessionUser | null): FeatureFlagUser | undefined {
  if (user === null) {
    return undefined
  }

  return {
    identifier: user.id,
    email: user.email,
    custom: { principal: 'staff' },
  }
}
